// extracted by mini-css-extract-plugin
export default {"label":"Filter_label__v4xEG","input":"Filter_input__PW1QF"};